import { Redirect } from 'react-router-dom';
import { SignUpEvent } from '@finch-api/common/dist/analytics/developer-dashboard-events';
import { useEvent } from '../shared/hooks/useEvent';

export const RegisterLoginEventAndRedirectToApp = () => {
  useEvent(SignUpEvent.UserLogin);

  return <Redirect to="/app" />;
};
